
/** Authorities Document DTO */
export interface AuthoritiesDocumentDTO {
  /** Property of land registration sheets */
  landRegistrationSheets?: LandRegistrationSheetDTO[]
  /** Whether to search land registration details */
  searchLandRegistrationDetails?: boolean
  /** Landlord information */
  landLordInformation?: LandLordInformationDTO
  /** Comment */
  comment?: string
  /** Data source of filled Land registration data **/
  dataSource?: AuthoritiesDocumentDataSource
}

/** Land Registration Sheet DTO */
export interface LandRegistrationSheetDTO {
  /** Land Registration Sheet name */
  name: string
  /** Land Registration Sheet district */
  district: string
  /** Land Registration Sheet floors */
  floors: LandRegistrationSheetFloorDTO[]
}

/** Land Registration Sheet Floor DTO */
export interface LandRegistrationSheetFloorDTO {
  /** Floor hallway */
  hallway: string
  /** Floor parcel */
  parcels: LandRegistrationSheetParcelDTO[]
}

export interface LandRegistrationSheetParcelDTO {
  /** Parcel number */
  number: string
}

/** Land Lord Information DTO */
export interface LandLordInformationDTO {
  /** Land lord firstname */
  firstName: string
  /** Land lord lastName */
  lastName: string
  /** Land lord dateOfBirth */
  dateOfBirth: string,
}

/** Data source enum, explaining, from where the data comes from */
export enum AuthoritiesDocumentDataSource {
  /** From the map selection */
  MAP = 'map',
}
